import type {
  Component,
  CreateComponentBody,
  UpdateComponentBody,
} from '@tasks/contracts';

import { apiRequestList, apiRequestResource, apiRequestVoid } from './client';

/**
 * Компоненты проекта (docs/13 §4).
 *
 * Чтение доступно участнику проекта, изменение — администратору проекта:
 * права проверяет сервер, интерфейс лишь скрывает недоступные действия.
 */
export function listComponents(
  key: string,
  options: { includeArchived?: boolean; signal?: AbortSignal } = {},
): Promise<Component[]> {
  const query = options.includeArchived ? '?includeArchived=1' : '';
  return apiRequestList<Component>(`/projects/${encodeURIComponent(key)}/components${query}`, {
    signal: options.signal,
  });
}

/** Создание и изменение отдают `{ component }` — огибающая ресурса (docs/05 §1). */
export function createComponent(key: string, body: CreateComponentBody): Promise<Component> {
  return apiRequestResource<Component>(
    `/projects/${encodeURIComponent(key)}/components`,
    'component',
    { method: 'POST', body },
  );
}

export function updateComponent(
  key: string,
  componentId: string,
  body: UpdateComponentBody,
): Promise<Component> {
  return apiRequestResource<Component>(
    `/projects/${encodeURIComponent(key)}/components/${encodeURIComponent(componentId)}`,
    'component',
    { method: 'PATCH', body },
  );
}

export function archiveComponent(key: string, componentId: string): Promise<Component> {
  return apiRequestResource<Component>(
    `/projects/${encodeURIComponent(key)}/components/${encodeURIComponent(componentId)}/archive`,
    'component',
    { method: 'POST' },
  );
}

export function restoreComponent(key: string, componentId: string): Promise<Component> {
  return apiRequestResource<Component>(
    `/projects/${encodeURIComponent(key)}/components/${encodeURIComponent(componentId)}/restore`,
    'component',
    { method: 'POST' },
  );
}

/** Окончательное удаление: сервер разрешает его только для компонента без задач. */
export function deleteComponent(key: string, componentId: string): Promise<void> {
  return apiRequestVoid(
    `/projects/${encodeURIComponent(key)}/components/${encodeURIComponent(componentId)}`,
    { method: 'DELETE' },
  );
}
